// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__s2pPi","controls":"styles_controls__1KBEr","charLimit":"styles_charLimit__3ZP0H","input":"styles_input__187Px","send":"styles_send__2KNcz"};